import { Footer, FooterMobile, HeaderB2B, HeaderB2BMobile } from 'components';
import Article from 'components/article/Detail';
import Others from 'components/article/Other';
import React from 'react';
import { useParams } from 'react-router-dom';

export default function BlogDetail({ isMobile = false }) {
  const category = 'blog';
  const { slug } = useParams();

  return (
    <div>
      {isMobile ? <HeaderB2BMobile /> : <HeaderB2B />}

      <Article slug={slug} category={category} />

      <Others title="Blog Kami" category={category} />

      {isMobile ? <FooterMobile /> : <Footer />}
    </div>
  );
}
